import { Breadcrumb } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useMatches } from 'react-router';

import type { ItemType } from 'antd/es/breadcrumb/Breadcrumb';

interface RouteHandle {
  breadcrumb?: string;
}

/**
 * Dumb component — derives breadcrumbs from React Router matches.
 * Routes that want a breadcrumb must export a `handle` with a `breadcrumb` key
 * that is a translation key from the 'common' namespace.
 */
export default function Breadcrumbs() {
  const { t } = useTranslation('common');
  const matches = useMatches();

  const crumbs: ItemType[] = matches
    .filter((match) => {
      const handle = match.handle as RouteHandle | undefined;
      return handle?.breadcrumb !== undefined;
    })
    .map((match) => {
      const handle = match.handle as RouteHandle;
      return {
        key: match.id,
        title: (
          <Link to={match.pathname}>
            {t(handle.breadcrumb as Parameters<typeof t>[0])}
          </Link>
        ),
      };
    });

  if (crumbs.length === 0) return null;

  return (
    <Breadcrumb
      items={crumbs}
      style={{ fontSize: 14 }}
      aria-label="Navegación de ruta"
    />
  );
}
